import dbAppOffline from '../db';
import commonRepository from '../../repositories/commonRepository';

const table = dbAppOffline.actuaciones;

const actuacionesRepository = {
  ...commonRepository(table),
};

export default actuacionesRepository;